import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

export const InventorySchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    category_id: z.string().uuid(),
    item_name: z.string(),
    price: z.string(), // API returns price as string with decimals
    created_at: z.string(),
    updated_at: z.string(),
    category: z.object({
        id: z.string().uuid(),
        name: z.string(),
    }).optional(),
});

export const InventoryResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(InventorySchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type InventoryResponse = z.infer<typeof InventoryResponseSchema>;
export type InventoryData = z.infer<typeof InventorySchema>;
